import React from "react";
import "./deleteModal.css";
import { CheckCircle, Close } from "@material-ui/icons";
import { Link, useHistory } from "react-router-dom";

function AddModal({ closeModal }) {
  let history = useHistory();

  return (
    <div className="modalBg">
      <div className="modalContainer">
        <div className="titleCloseBtn">
          <div></div>
          <button className="doneIcon">
            <CheckCircle className="checkMarkIcon" />
          </button>
          <button
            className="closeModalBtn"
            onClick={() => {
              history.goBack();
              closeModal(false);
            }}
          >
            <Close />
          </button>
        </div>
        <div className="modalTxt">User Added Successfully</div>
      </div>
    </div>
  );
}

export default AddModal;
